import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

import { LookupForm } from "@/components/lookup-form";
import { QueryState } from "@/components/query-state";
import { UtxoTable } from "@/features/utxos/UtxoTable";
import type { LookupUtxoParams } from "@/generated/api/model";
import { useLookupUtxo } from "@/generated/api/utxos/utxos";

export const Route = createFileRoute("/utxos")({ component: Utxos });

const FIELDS = [
    { name: "transaction_id", label: "Transaction id", placeholder: "64 hex characters" },
    { name: "index", label: "Output index", placeholder: "0", inputMode: "numeric" },
] as const;

function Utxos() {
    const [input, setInput] = useState<LookupUtxoParams | null>(null);

    return (
        <div className="space-y-4">
            <LookupForm
                fields={FIELDS}
                onSubmit={({ transaction_id, index }) => setInput({ transaction_id, index: Number(index) })}
            />
            {input && <Utxo input={input} />}
        </div>
    );
}

function Utxo({ input }: { input: LookupUtxoParams }) {
    const utxo = useLookupUtxo(input);
    return (
        <QueryState query={utxo} isEmpty={() => false} emptyMessage="No such UTXO.">
            {(data) => <UtxoTable utxos={[data.utxo]} label="UTXO" />}
        </QueryState>
    );
}
